import { useDispatch } from 'react-redux';
import { useKeycloak } from '@react-keycloak/web';
import { likeMedia, unlikeMedia } from '../../store/reducers/media.reducer';

export const useToggleLike = () => {
    const dispatch = useDispatch();
    const { keycloak } = useKeycloak();

    const toggleLike = (mediaPoint) => {
        if (!keycloak.token || !mediaPoint) return;

        const isCurrentlyLiked = mediaPoint.likedByCurrentUser;

        if (isCurrentlyLiked) {
            dispatch(unlikeMedia({ mediaId: mediaPoint.id, token: keycloak.token }));
        } else {
            dispatch(likeMedia({ mediaId: mediaPoint.id, token: keycloak.token }));
        }
    };

    return { toggleLike };
};